import React from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { ProgressBar } from '../components/ui/ProgressBar';
import { SearchIcon, FilterIcon, BookOpenIcon, PlayCircleIcon, AwardIcon, ClockIcon, ChevronRightIcon, BookIcon, VideoIcon, CheckCircleIcon } from 'lucide-react';
export const Courses: React.FC = () => {
  return <div data-id="element-619">
      <div className="flex justify-between items-center mb-6" data-id="element-620">
        <h1 className="text-2xl font-bold text-navy" data-id="element-621">Learning</h1>
        <Button variant="primary" icon={<BookOpenIcon size={16} data-id="element-623" />} data-id="element-622">
          Browse Courses
        </Button>
      </div>
      <div className="mb-6" data-id="element-624">
        <div className="relative mb-4" data-id="element-625">
          <input type="text" placeholder="Search courses, skills, or certifications..." className="w-full p-3 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-626" />
          <SearchIcon size={20} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-627" />
        </div>
        <div className="flex gap-2 overflow-x-auto pb-2 hide-scrollbar" data-id="element-628">
          <Button variant="outline" size="sm" data-id="element-629">
            All
          </Button>
          <Button variant="primary" size="sm" data-id="element-630">
            In Progress
          </Button>
          <Button variant="outline" size="sm" data-id="element-631">
            Completed
          </Button>
          <Button variant="outline" size="sm" data-id="element-632">
            PADI
          </Button>
          <Button variant="outline" size="sm" data-id="element-633">
            SSI
          </Button>
          <Button variant="outline" size="sm" data-id="element-634">
            NAUI
          </Button>
          <Button variant="outline" size="sm" icon={<FilterIcon size={14} data-id="element-636" />} data-id="element-635">
            Filter
          </Button>
        </div>
      </div>
      <Card className="mb-6" data-id="element-637">
        <div className="flex items-center justify-between mb-4" data-id="element-638">
          <h2 className="font-semibold" data-id="element-639">Continue Learning</h2>
          <Button variant="outline" size="sm" data-id="element-640">
            View All
          </Button>
        </div>
        <div className="space-y-4" data-id="element-641">
          <div className="border rounded-lg p-4" data-id="element-642">
            <div className="flex justify-between items-start" data-id="element-643">
              <div data-id="element-644">
                <h3 className="font-medium" data-id="element-645">Rescue Diver Certification</h3>
                <p className="text-sm text-gray-500" data-id="element-646">PADI</p>
              </div>
              <Badge variant="primary" data-id="element-647">In Progress</Badge>
            </div>
            <ProgressBar value={65} max={100} variant="primary" className="my-3" showLabel data-id="element-648" />
            <div className="flex justify-between items-center mt-2" data-id="element-649">
              <div className="flex items-center text-sm text-gray-600" data-id="element-650">
                <ClockIcon size={16} className="mr-1" data-id="element-651" />
                <span data-id="element-652">Last activity: 2 days ago</span>
              </div>
              <Button variant="primary" size="sm" icon={<PlayCircleIcon size={16} data-id="element-654" />} data-id="element-653">
                Continue
              </Button>
            </div>
          </div>
          <div className="border rounded-lg p-4" data-id="element-655">
            <div className="flex justify-between items-start" data-id="element-656">
              <div data-id="element-657">
                <h3 className="font-medium" data-id="element-658">Underwater Photography Basics</h3>
                <p className="text-sm text-gray-500" data-id="element-659">Specialty Course</p>
              </div>
              <Badge variant="primary" data-id="element-660">In Progress</Badge>
            </div>
            <ProgressBar value={30} max={100} variant="primary" className="my-3" showLabel data-id="element-661" />
            <div className="flex justify-between items-center mt-2" data-id="element-662">
              <div className="flex items-center text-sm text-gray-600" data-id="element-663">
                <ClockIcon size={16} className="mr-1" data-id="element-664" />
                <span data-id="element-665">Last activity: 5 days ago</span>
              </div>
              <Button variant="primary" size="sm" icon={<PlayCircleIcon size={16} data-id="element-667" />} data-id="element-666">
                Continue
              </Button>
            </div>
          </div>
        </div>
      </Card>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-668">
        <Card data-id="element-669">
          <div className="flex items-center justify-between mb-4" data-id="element-670">
            <h2 className="font-semibold" data-id="element-671">My Certifications</h2>
            <Button variant="outline" size="sm" data-id="element-672">
              View All
            </Button>
          </div>
          <div className="space-y-4" data-id="element-673">
            <div className="flex items-center gap-3 border-b pb-3" data-id="element-674">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center text-primary" data-id="element-675">
                <AwardIcon size={24} data-id="element-676" />
              </div>
              <div className="flex-1" data-id="element-677">
                <h3 className="font-medium" data-id="element-678">Open Water Diver</h3>
                <p className="text-sm text-gray-500" data-id="element-679">
                  PADI • Completed June 2021
                </p>
              </div>
              <Button variant="ghost" size="sm" icon={<ChevronRightIcon size={16} data-id="element-681" />} data-id="element-680" />
            </div>
            <div className="flex items-center gap-3 border-b pb-3" data-id="element-682">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center text-primary" data-id="element-683">
                <AwardIcon size={24} data-id="element-684" />
              </div>
              <div className="flex-1" data-id="element-685">
                <h3 className="font-medium" data-id="element-686">Advanced Open Water</h3>
                <p className="text-sm text-gray-500" data-id="element-687">
                  PADI • Completed August 2021
                </p>
              </div>
              <Button variant="ghost" size="sm" icon={<ChevronRightIcon size={16} data-id="element-689" />} data-id="element-688" />
            </div>
            <div className="flex items-center gap-3" data-id="element-690">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center text-primary" data-id="element-691">
                <AwardIcon size={24} data-id="element-692" />
              </div>
              <div className="flex-1" data-id="element-693">
                <h3 className="font-medium" data-id="element-694">Nitrox Specialty</h3>
                <p className="text-sm text-gray-500" data-id="element-695">
                  PADI • Completed October 2021
                </p>
              </div>
              <Button variant="ghost" size="sm" icon={<ChevronRightIcon size={16} data-id="element-697" />} data-id="element-696" />
            </div>
          </div>
        </Card>
        <Card data-id="element-698">
          <div className="flex items-center justify-between mb-4" data-id="element-699">
            <h2 className="font-semibold" data-id="element-700">Recommended Courses</h2>
            <Button variant="outline" size="sm" data-id="element-701">
              View All
            </Button>
          </div>
          <div className="space-y-4" data-id="element-702">
            <div className="flex gap-3 border-b pb-3" data-id="element-703">
              <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden" data-id="element-704">
                <img src="https://images.unsplash.com/photo-1682687982167-d7fb3ed8541d?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80" alt="Course" className="w-full h-full object-cover" data-id="element-705" />
              </div>
              <div className="flex-1" data-id="element-706">
                <h3 className="font-medium" data-id="element-707">Divemaster Certification</h3>
                <p className="text-sm text-gray-600" data-id="element-708">
                  PADI Professional Course
                </p>
                <div className="flex items-center gap-3 mt-1 text-xs text-gray-500" data-id="element-709">
                  <span className="flex items-center" data-id="element-710">
                    <ClockIcon size={12} className="mr-1" data-id="element-711" />
                    6-8 weeks
                  </span>
                  <span data-id="element-712">4.9 ★</span>
                </div>
              </div>
            </div>
            <div className="flex gap-3" data-id="element-713">
              <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden" data-id="element-714">
                <img src="https://images.unsplash.com/photo-1544551763-92ab472cad5d?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80" alt="Course" className="w-full h-full object-cover" data-id="element-715" />
              </div>
              <div className="flex-1" data-id="element-716">
                <h3 className="font-medium" data-id="element-717">Wreck Diving Specialty</h3>
                <p className="text-sm text-gray-600" data-id="element-718">PADI Specialty Course</p>
                <div className="flex items-center gap-3 mt-1 text-xs text-gray-500" data-id="element-719">
                  <span className="flex items-center" data-id="element-720">
                    <ClockIcon size={12} className="mr-1" data-id="element-721" />
                    2-3 days
                  </span>
                  <span data-id="element-722">4.8 ★</span>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <Card data-id="element-723">
        <h2 className="font-semibold mb-4" data-id="element-724">Current Course: Rescue Diver</h2>
        <div className="bg-primary/5 rounded-lg p-4 mb-4" data-id="element-725">
          <div className="flex items-center gap-2 mb-2" data-id="element-726">
            <div className="w-10 h-10 bg-primary/20 rounded-full flex items-center justify-center text-primary" data-id="element-727">
              <BookIcon size={20} data-id="element-728" />
            </div>
            <div data-id="element-729">
              <h3 className="font-medium" data-id="element-730">Module 3: Rescue Scenarios</h3>
              <p className="text-sm text-gray-600" data-id="element-731">4 lessons • 2 quizzes</p>
            </div>
          </div>
          <ProgressBar value={50} variant="primary" className="mb-3" data-id="element-732" />
          <div className="space-y-2" data-id="element-733">
            <div className="flex items-center justify-between p-2 rounded-lg bg-white" data-id="element-734">
              <div className="flex items-center gap-2" data-id="element-735">
                <CheckCircleIcon size={16} className="text-success" data-id="element-736" />
                <span className="text-sm" data-id="element-737">
                  Introduction to Rescue Techniques
                </span>
              </div>
              <Badge variant="success" data-id="element-738">Completed</Badge>
            </div>
            <div className="flex items-center justify-between p-2 rounded-lg bg-white" data-id="element-739">
              <div className="flex items-center gap-2" data-id="element-740">
                <CheckCircleIcon size={16} className="text-success" data-id="element-741" />
                <span className="text-sm" data-id="element-742">Self-Rescue Skills</span>
              </div>
              <Badge variant="success" data-id="element-743">Completed</Badge>
            </div>
            <div className="flex items-center justify-between p-2 rounded-lg bg-white" data-id="element-744">
              <div className="flex items-center gap-2" data-id="element-745">
                <VideoIcon size={16} className="text-primary" data-id="element-746" />
                <span className="text-sm" data-id="element-747">Assisting Tired Divers</span>
              </div>
              <Button variant="primary" size="sm" data-id="element-748">
                Continue
              </Button>
            </div>
            <div className="flex items-center justify-between p-2 rounded-lg bg-white" data-id="element-749">
              <div className="flex items-center gap-2" data-id="element-750">
                <BookIcon size={16} className="text-gray-400" data-id="element-751" />
                <span className="text-sm" data-id="element-752">Quiz: Rescue Scenarios</span>
              </div>
              <Badge variant="secondary" data-id="element-753">Locked</Badge>
            </div>
          </div>
        </div>
        <Button variant="primary" fullWidth data-id="element-754">
          Continue Learning
        </Button>
      </Card>
    </div>;
};